import { RESULT_LIST, RESULT_APPROVE_REJECT, RESULT_GETONE, RESULT_ALLOW_EDIT } from "../../api/constApi";
import { authHeader } from "./authHeader";
import { apiInstance } from "./axiosApi";


export const resultListApi = (payload) => {
    return apiInstance.post(RESULT_LIST, payload, {
        headers: authHeader(),
    });
};

export const resultGetoneApi = (payload) => {
    return apiInstance.post(RESULT_GETONE, payload, {
        headers: authHeader(),
    });
};

export const approveRejectResultpi = (payload) => {
    return apiInstance.post(RESULT_APPROVE_REJECT, payload, {
        headers: authHeader(),
    });
};

export const allowEditResultApi = (payload) => {
    return apiInstance.post(RESULT_ALLOW_EDIT, payload, {
        headers: authHeader(),
    });
};